import API_BASE_URL from '../config/api';
import React from 'react';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import {
	Button,
	Glyphicon,
	Grid,
	Col,
	Well,
	Row,
	FormGroup,
	ControlLabel,
	PageHeader
} from '../../node_modules/react-bootstrap/lib/';
import { bindActionCreators } from 'redux';
import { importData } from '../actions/index';
import {
	Pedestrismo,
	RuralBike,
	CombinadaSprint,
	CombinadaSimple,
	PedestrismoBackup
} from '../constants/enums';
import axios from 'axios';
import Form from 'react-bootstrap/lib/Form';

class ProcessAthletesList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isLoadingOnCloud: false,
			infoList: [],
			caption: 'Seleccione origen del padron de atletas',
			catStats: [],
			gralStats: [],
			participantList: [],
			sendButtonFromCloud: 'Importar',
			data: [],
			cols: []
		};

		this.handleFile = this.handleFile.bind(this);
		this.handleCloud = this.handleCloud.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

componentDidMount() {

	console.log(
		'Evento:',
		this.props.eventID
	);


	/*
	 * =====================================================
	 * RECUPERAR PADRON DESDE REDUX
	 * =====================================================
	 *
	 * Si la aplicación fue restaurada desde localStorage,
	 * reducerRegisterTime ya contiene participantList.
	 *
	 * Este componente muestra la tabla desde this.state.data,
	 * por lo tanto reconstruimos esa representación local.
	 */
	const participantList =
		Array.isArray(
			this.props.participantList
		)
			? this.props.participantList
			: [];


	if (
		participantList.length > 0
	) {

		const restoredData =
			participantList.map(
				(participant) => {

					return [

						participant.id,

						participant.chip,

						participant.number,

						participant.last,

						participant.first,

						participant.gender,

						participant.birth,

						participant.dni,

						participant.age,

						participant.catCod,

						participant.catName,

						participant.catRange,

						participant.club,

						participant.city,

						participant.phone,

						parseInt(
							participant.competition || 0,
							10
						),

						participant.order,

						participant.distance,

						participant.distanceID,

						participant.distanceName
					];
				}
			);


		const restoredCols =
			Array.from(
				{
					length: 20
				},
				(_, index) => ({
					name:
						String.fromCharCode(
							65 + index
						),

					key:
						index
				})
			);


		this.setState({

			data:
				restoredData,

			cols:
				restoredCols,

			infoList:
				participantList,

			caption:
				'Se recuperaron ' +
				participantList.length +
				' participantes desde la carrera guardada.'
		});


		console.log(
			'Inscriptos desde cloud:',
			participantList.length,
			'participantes'
		);
	}
}

componentDidUpdate(
	prevProps
) {

	if (
		prevProps.participantList !==
			this.props.participantList
	) {

		const participantList =
			Array.isArray(
				this.props.participantList
			)
				? this.props.participantList
				: [];


		if (
			participantList.length === 0
		) {

			return;
		}


		const restoredData =
			participantList.map(
				(participant) => {

					return [

						participant.id,

						participant.chip,

						participant.number,

						participant.last,

						participant.first,

						participant.gender,

						participant.birth,

						participant.dni,

						participant.age,

						participant.catCod,

						participant.catName,

						participant.catRange,

						participant.club,

						participant.city,

						participant.phone,

						parseInt(
							participant.competition || 0,
							10
						),

						participant.order,

						participant.distance,

						participant.distanceID,

						participant.distanceName
					];
				}
			);


		const restoredCols =
			Array.from(
				{
					length: 20
				},
				(_, index) => ({
					name:
						String.fromCharCode(
							65 + index
						),

					key:
						index
				})
			);


		this.setState({

			data:
				restoredData,

			cols:
				restoredCols,

			infoList:
				participantList,

			caption:
				'Se recuperaron ' +
				participantList.length +
				' participantes desde Cloud.'
		});
	}
}

	handleFile(file) {
		const reader = new FileReader();
		const rABS = !!reader.readAsBinaryString;

		reader.onload = (e) => {
			const bstr = e.target.result;

			const wb = XLSX.read(
				bstr,
				{
					type: rABS ? 'binary' : 'array'
				}
			);

			//pelado

			const wsname = wb.SheetNames[0];
			const ws = wb.Sheets[wsname];

			let range = XLSX.utils.decode_range(ws['!ref']);

			// Salta la primera fila.
			range.s.r = 1;
			ws['!ref'] = XLSX.utils.encode_range(range);

			const data = XLSX.utils.sheet_to_json(
				ws,
				{
					header: 1
				}
			);

			this.setState({
				caption:
					'Verifique los datos leidos y luego haga clic en Importar',
				data: data,
				cols: make_cols(ws['!ref'])
			});
		};

		reader.readAsBinaryString(file);
	}

	transformEnrollments(enrollments) {
		const transformedEnrollments = enrollments.map((enrollment) => {
			return [
				enrollment.id,
				enrollment.chip,
				enrollment.number,
				enrollment.last,
				enrollment.first,
				enrollment.gender,
				enrollment.birth,
				enrollment.dni,
				enrollment.age,
				enrollment.cat_cod,
				enrollment.cat_name,
				enrollment.cat_range,
				enrollment.club,
				enrollment.city,
				enrollment.phone,
				parseInt(enrollment.competition, 10),
				enrollment.order,
				enrollment.distance,
				enrollment.distanceID,
				enrollment.distanceName
			];
		});

		const cols = Array.from(
			{
				length: 20
			},
			(_, index) => ({
				name: String.fromCharCode(65 + index),
				key: index
			})
		);

		this.setState({
			data: transformedEnrollments,
			cols: cols
		});

		return transformedEnrollments;
	}

	parse() {
		const importList = this.state.data.slice(0);
		const resultList = [];

		for (let i = 0; i < importList.length; i++) {
			const athlete = {
				id: 0,
				chip: '',
				number: 0,
				last: '',
				first: '',
				gender: '',
				birth: '',
				dni: '',
				age: 0,
				catCod: '',
				catName: '',
				catRange: '',
				club: '',
				city: '',
				phone: '',
				competition: 0,
				order: 0,
				distance: 0,
				distanceID: 0,
				distanceName: '',

				posGral: 0,
				posGender: 0,
				posCat: 0,

				registeredTime1: 0,
				registeredTime2: 0,
				registeredTime3: 0,

				formattedTime1: '',
				formattedTime2: '',
				formattedTime3: ''
			};

			Object.keys(athlete).forEach((key, index) => {
				if (index >= 20 && index <= 25) {
					athlete[key] = 0;
				} else {
					athlete[key] = importList[i][index];
				}
			});

			athlete.fullname =
				athlete.last + ', ' + athlete.first;

			athlete.disqualified = 0;

			const teamMember = {
				id: athlete.id,
				first: athlete.first,
				last: athlete.last,
				number: athlete.number,
				city: athlete.city,
				phone: athlete.phone,
				gender: athlete.gender,
				distance: athlete.distance,
				distanceID: athlete.distanceID,
				catCod: athlete.catCod,
				catName: athlete.catName,
				club: athlete.club,
				fullname: athlete.fullname
			};

			athlete.team = [teamMember];

			resultList.push(athlete);
		}

		this.setState({
			infoList: resultList
		});

		const catUnique = this.removeDuplicates(
			resultList,
			'catCod'
		);

		const stats = [];

		for (let i = 0; i < catUnique.length; i++) {
			stats[i] = {
				category: catUnique[i].catCod,
				total: 0,
				distance: catUnique[i].distance,
				label: catUnique[i].catName,
				gender: catUnique[i].gender,
				order: catUnique[i].order,
				range: catUnique[i].catRange,
				distanceName: catUnique[i].distanceName
			};
		}

		for (let i = 0; i < stats.length; i++) {
			stats[i].total = this.getCategoryStats(
				stats[i].category,
				resultList
			);
		}

		for (let i = 0; i < resultList.length; i++) {
			for (let j = 0; j < stats.length; j++) {
				if (
					stats[j].category ===
					resultList[i].catCod
				) {
					resultList[i].totalCat =
						stats[j].total;
				}
			}
		}

		let gralStats = [];

		if (
			this.props.competition === CombinadaSimple ||
			this.props.competition === CombinadaSprint
		) {
			const uniqueDistances = this.removeDuplicates(
				resultList,
				'distanceName'
			);

			for (
				let i = 0;
				i < uniqueDistances.length;
				i++
			) {
				gralStats[i] = {
					distancia:
						uniqueDistances[i].distanceName,
					total: 0,
					label:
						uniqueDistances[i].distanceName
				};
			}

			for (
				let i = 0;
				i < resultList.length;
				i++
			) {
				for (
					let j = 0;
					j < gralStats.length;
					j++
				) {
					const total = resultList.filter(
						(athlete) => {
							return (
								gralStats[j].distancia ===
								athlete.distanceName
							);
						}
					);

					gralStats[j].total =
						total.length;
				}
			}
		}

		if (
			this.props.competition === Pedestrismo ||
			this.props.competition === PedestrismoBackup
		) {
			const configuredDistances = [
				this.props.distance1Type,
				this.props.distance2Type,
				this.props.distance3Type
			]
				.filter((distance) => {
					return (
						distance !== undefined &&
						distance !== null &&
						String(distance).trim() !== ''
					);
				})
				.map((distance) => {
					return String(distance).trim();
				});

			gralStats = configuredDistances.map(
				(distance) => {
					const total = resultList.filter(
						(athlete) => {
							return (
								String(
									athlete.distance
								).trim() === distance
							);
						}
					);

					return {
						distancia: distance,
						total: total.length
					};
				}
			);

			for (
				let i = 0;
				i < resultList.length;
				i++
			) {
				for (
					let j = 0;
					j < gralStats.length;
					j++
				) {
					if (
						String(
							gralStats[j].distancia
						).trim() ===
						String(
							resultList[i].distance
						).trim()
					) {
						resultList[i].totalGral =
							gralStats[j].total;
					}
				}
			}
		}

		if (this.props.competition === RuralBike) {
			this.setState({
				caption:
					'Se cargaron ' +
					this.state.data.length +
					' participantes.',
				catStats: stats,
				gralStats: gralStats
			});

			return resultList;
		}

		if (
			this.props.competition === Pedestrismo ||
			this.props.competition === PedestrismoBackup
		) {
			const configuredDistances = [
				this.props.distance1Type,
				this.props.distance2Type,
				this.props.distance3Type
			]
				.filter((distance) => {
					return (
						distance !== undefined &&
						distance !== null &&
						String(distance).trim() !== ''
					);
				})
				.map((distance) => {
					return String(distance).trim();
				});

			const importedDistances =
				this.removeDuplicates(
					resultList,
					'distance'
				).map((athlete) => {
					return String(
						athlete.distance
					).trim();
				});

			const sameAmount =
				configuredDistances.length ===
				importedDistances.length;

			const sameDistances =
				sameAmount &&
				configuredDistances.every(
					(distance) => {
						return (
							importedDistances.indexOf(
								distance
							) !== -1
						);
					}
				);

			if (sameDistances) {
				this.setState({
					caption:
						'Se cargaron ' +
						this.state.data.length +
						' participantes.',
					catStats: stats,
					gralStats: gralStats
				});

				return resultList;
			}

			this.setState({
				caption:
					'Las distancias no coinciden. Configuradas: ' +
					(
						configuredDistances.join(', ') ||
						'ninguna'
					) +
					'. Importadas: ' +
					(
						importedDistances.join(', ') ||
						'ninguna'
					)
			});

			return;
		}

		if (
			this.props.competition === CombinadaSprint ||
			this.props.competition === CombinadaSimple
		) {
			const numbersUnique =
				this.removeDuplicates(
					resultList,
					'number'
				);

			const combinadaResultList = [];

			for (
				let i = 0;
				i < numbersUnique.length;
				i++
			) {
				const posta = resultList.filter(
					(athlete) => {
						return (
							athlete.number ===
							numbersUnique[i].number
						);
					}
				);

				if (posta.length === 3) {
					const athlete = {
						id: posta[0].id,
						number: posta[0].number,
						city: '',
						catCod: posta[0].catCod,
						catName: posta[0].catName,
						gender: '',

						registeredTime1: 0,
						registeredTime2: 0,
						registeredTime3: 0,

						last:
							posta[0].last +
							'-' +
							posta[1].last +
							'-' +
							posta[2].last,

						fullname:
							posta[0].last +
							', ' +
							posta[0].first +
							' / ' +
							posta[1].last +
							', ' +
							posta[1].first +
							' / ' +
							posta[2].last +
							', ' +
							posta[2].first,

						totalCat:
							posta[0].totalCat,

						competition:
							posta[0].competition,

						bike: '',

						team: [
							posta[0].team[0],
							posta[1].team[0],
							posta[2].team[0]
						]
					};

					combinadaResultList.push(
						athlete
					);
				} else if (posta.length === 2) {
					const athlete = {
						id: posta[0].id,
						number: posta[0].number,
						city: '',
						catCod: posta[0].catCod,
						catName: posta[0].catName,
						gender: '',

						registeredTime1: 0,
						registeredTime2: 0,
						registeredTime3: 0,

						last:
							posta[0].last +
							'-' +
							posta[1].last,

						fullname:
							posta[0].last +
							', ' +
							posta[0].first +
							' / ' +
							posta[1].last +
							', ' +
							posta[1].first,

						totalCat:
							posta[0].totalCat,

						competition:
							posta[0].competition,

						bike: '',

						team: [
							posta[0].team[0],
							posta[1].team[0]
						]
					};

					combinadaResultList.push(
						athlete
					);
				} else if (posta.length === 1) {
					combinadaResultList.push(
						posta[0]
					);
				} else {
					this.setState({
						caption:
							'Verifique la NUMERACIÓN de los atletas'
					});

					return;
				}
			}

			this.setState({
				caption:
					'Se cargaron ' +
					this.state.data.length +
					' participantes.',
				catStats: stats
			});

			return combinadaResultList;
		}
	}

	getCategoryStats(category, athletes) {
		const filteredAthletes = athletes.filter(
			(athlete) => {
				return athlete.catCod === category;
			}
		);

		return filteredAthletes.length;
	}

	removeDuplicates(myArr, prop) {
		return myArr.filter(
			(obj, pos, arr) => {
				return (
					arr
						.map((mapObj) => mapObj[prop])
						.indexOf(obj[prop]) === pos
				);
			}
		);
	}

	toTitleCase(str) {
		return str.replace(
			/\w\S*/g,
			(txt) => {
				return (
					txt.charAt(0).toUpperCase() +
					txt
						.substr(1)
						.toLowerCase()
				);
			}
		);
	}

	handleCloud(e) {
		e.preventDefault();

		this.setState({
			isLoadingOnCloud: true
		});

		axios
			.get(
				(API_BASE_URL + '/races/') +
				this.props.eventID +
				'/enrollments/for-cloud'
			)
			.then((response) => {
				if (
					response.status === 200 &&
					response.data.result !== null
				) {
					const transformedData =
						this.transformEnrollments(
							response.data.result
						);

					this.setState(
						{
							data: transformedData
						},
						() => {
							setTimeout(() => {
								const parsedData =
									this.parse();

								if (parsedData) {
									this.props.importData(
										parsedData,
										this.state.infoList,
										this.state.catStats,
										this.state.gralStats
									);
								}

								this.setState({
									isLoadingOnCloud: false
								});
							}, 50);
						}
					);
				} else {
					this.setState({
						caption:
							'Hubo un problema al cargar los inscriptos. Revise la configuración del evento y verifique que GUARDAR CAMBIOS este en color VERDE.',
						bsStyle: 'danger',
						isLoadingOnCloud: false,
						label: 'Error'
					});
				}
			})
			.catch(() => {
				this.setState({
					caption:
						'Hubo un problema al cargar los inscriptos.',
					bsStyle: 'danger',
					isLoadingOnCloud: false,
					label: 'Error'
				});
			});
	}

	handleClick() {
		this.setState(
			{
				isLoading: true
			},
			() => {
				setTimeout(() => {
					const parsedData =
						this.parse();

					if (parsedData) {
						this.props.importData(
							parsedData,
							this.state.infoList,
							this.state.catStats,
							this.state.gralStats
						);
					}

					this.setState({
						isLoading: false
					});
				}, 50);
			}
		);
	}

	render() {
		const title = (
			<Row className="show-grid">
				<Col md={12}>
					<PageHeader>
						<center>
							Atletas {this.props.name}
						</center>
					</PageHeader>
				</Col>
			</Row>
		);

		const isLoading =
			this.state.isLoading;

		const isLoadingOnCloud =
			this.state.isLoadingOnCloud;

		return (
			<Grid fluid>
				{title}

				<Form>
					<div className="row">
						<div className="col-xs-12">
							<Well>
								{this.state.caption}
							</Well>
						</div>
					</div>

					<FormGroup>
						<Col
							componentClass={ControlLabel}
							sm={3}
						>
							Cargar desde Cloud:
						</Col>

						<Col sm={6}>
							<Button
								onClick={
									!isLoadingOnCloud
										? this.handleCloud
										: null
								}
								bsStyle="primary"
								type="submit"
							>
								{isLoadingOnCloud
									? 'Leyendo...'
									: 'Importar'}
							</Button>
						</Col>
					</FormGroup>

					<FormGroup>
						<Col>&nbsp;</Col>
					</FormGroup>

					<FormGroup>
						<Col
							componentClass={ControlLabel}
							sm={3}
						>
							Cargar desde Excel/CSV:
						</Col>

						<Col
							componentClass={ControlLabel}
							sm={4}
						>
							<DragDropFile
								handleFile={
									this.handleFile
								}
							>
								<div className="row">
									<div className="col-xs-12">
										<DataInput
											handleFile={
												this.handleFile
											}
										/>
									</div>
								</div>
							</DragDropFile>
						</Col>
					</FormGroup>

					<FormGroup>
						<Col>
							<div className="row">
								<Button
									bsStyle="primary"
									disabled={
										this.props.competition ===
											0 ||
										this.props.startedAt >
											0 ||
										this.state.data
											.length === 0
									}
									onClick={
										!isLoading
											? this.handleClick
											: null
									}
								>
									{isLoading
										? 'Leyendo...'
										: 'Importar'}
								</Button>
							</div>
						</Col>
					</FormGroup>

					<FormGroup>
						<Col>&nbsp;</Col>
					</FormGroup>

					<div className="row">
						<div className="col-xs-12">
							<OutTable
								data={
									this.state.data
								}
								cols={
									this.state.cols
								}
							/>
						</div>
					</div>
				</Form>
			</Grid>
		);
	}
}

function mapStateToProps(state) {
	const {
		participantList
	} = state.reducerRegisterTime;

	const {
		startedAt
	} = state.reducerTimer;

	const {
		eventID,
		competition,

		distance1Type,
		distance1Value,

		distance2Type,
		distance2Value,

		distance3Type,
		distance3Value,

		totals,
		name
	} = state.reducerRegisterInfo;

	return {
		startedAt,
		participantList,

		distance1Type,
		distance1Value,

		distance2Type,
		distance2Value,

		distance3Type,
		distance3Value,

		competition,
		totals,
		eventID,
		name
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			importData
		},
		dispatch
	);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProcessAthletesList);

class DragDropFile extends React.Component {

	constructor(props) {
		super(props);

		this.onDrop =
			this.onDrop.bind(this);
	}

	suppress(evt) {
		evt.stopPropagation();
		evt.preventDefault();
	}

	onDrop(evt) {
		evt.stopPropagation();
		evt.preventDefault();

		const files =
			evt.dataTransfer.files;

		if (files && files[0]) {
			this.props.handleFile(
				files[0]
			);
		}
	}

	render() {
		return (
			<div
				onDrop={this.onDrop}
				onDragEnter={this.suppress}
				onDragOver={this.suppress}
			>
				{this.props.children}
			</div>
		);
	}
}

class DataInput extends React.Component {

	constructor(props) {
		super(props);

		this.handleChange =
			this.handleChange.bind(this);
	}

	handleChange(e) {
		const files =
			e.target.files;

		if (files && files[0]) {
			this.props.handleFile(
				files[0]
			);
		}
	}

	render() {
		return (
			<form className="form-inline">
				<div className="form-group">
					<input
						disabled={
							this.props.disabled
						}
						type="file"
						className="form-control"
						id="file"
						accept={SheetJSFT}
						onChange={
							this.handleChange
						}
					/>
				</div>
			</form>
		);
	}
}

class OutTable extends React.Component {

	render() {
		return (
			<div className="table-responsive">
				<table className="table table-striped table-bordered table-hover table-responsive">
					<thead>
						<tr>
							{this.props.cols.map(
								(column) => (
									<th
										key={
											column.key
										}
									>
										{
											column.name
										}
									</th>
								)
							)}
						</tr>
					</thead>

					<tbody>
						{this.props.data.map(
							(row, rowIndex) => (
								<tr key={rowIndex}>
									{this.props.cols.map(
										(column) => (
											<td
												key={
													column.key
												}
											>
												{
													row[
														column
															.key
													]
												}
											</td>
										)
									)}
								</tr>
							)
						)}
					</tbody>
				</table>
			</div>
		);
	}
}

const SheetJSFT = [
	'xlsx',
	'xlsb',
	'xlsm',
	'xls',
	'xml',
	'csv',
	'txt',
	'ods',
	'fods',
	'uos',
	'sylk',
	'dif',
	'dbf',
	'prn',
	'qpw',
	'123',
	'wb*',
	'wq*',
	'html',
	'htm'
]
	.map((extension) => {
		return '.' + extension;
	})
	.join(',');

function s2ab(s) {
	const buf =
		new ArrayBuffer(s.length);

	const view =
		new Uint8Array(buf);

	for (
		let i = 0;
		i !== s.length;
		++i
	) {
		view[i] =
			s.charCodeAt(i) & 0xff;
	}

	return buf;
}

const make_cols = (refstr) => {
	return Array(
		XLSX.utils.decode_range(refstr).e.c +
			1
	)
		.fill(0)
		.map((x, i) => ({
			name:
				XLSX.utils.encode_col(i),
			key: i
		}));
};



// WEBPACK FOOTER //
// ./src/containers/process-athletes-list.js